import type fr from '../fr/payouts';

const en: typeof fr = {
  simulation: 'Simulation mode (no real money)',
  worker: {
    title: 'Pay deposits',
    explain: 'Set up once the account where you receive your pay (self-employed). Setup happens on Stripe’s secure page.',
    incomplete: 'Your payout account setup is not finished.',
    enabled: 'Your account is ready: your approved pay will be sent there.',
    privacy: 'Your banking details are entered at Stripe and never stored in the app.',
    setup: 'Set up my deposits',
    continue: 'Finish setup',
    ready: 'Your payout account is ready.',
    resume: 'Setup was interrupted. You can resume it.',
  },
  admin: {
    title: 'Employee payouts',
    explain: 'Sends approved pay to each self-employed worker’s account (one transfer per person).',
    payAll: 'Pay approved pay ({{amount}})',
    ready: 'Ready',
    incomplete: 'Setup incomplete',
    noAccount: 'No account',
    history: 'Recent payouts',
    entries_one: '{{count}} job',
    entries_other: '{{count}} jobs',
    confirmTitle: 'Pay {{amount}}?',
    confirmText_one: 'One transfer will be sent to {{count}} employee. Employees without a ready account are skipped.',
    confirmText_other: 'One transfer will be sent to each of the {{count}} employees. Employees without a ready account are skipped.',
    confirm: 'Pay now',
    done_one: '{{count}} payout sent ({{amount}}). Skipped: {{skipped}}.',
    done_other: '{{count}} payouts sent ({{amount}}). Skipped: {{skipped}}.',
  },
  status: { PENDING: 'In progress', PAID: 'Paid', FAILED: 'Failed' },
};
export default en;
